import {madnes_fill_range, madnes_join} from "../framework/src/engine/madnes/madnes";

export var cylinder_pos_top = 52;
export var cylinder_pos = new Array();
cylinder_pos[0] = 334;
cylinder_pos[1] = 640;
cylinder_pos[2] = 948;


// Animace jednotlivych symbolu + pozice ve sprite
/*
var icons = {
    "symbol_Bar": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,48), 0)
    },
    "symbol_Bell": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,32), 0)
    },
    "symbol_Dollar": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,32), 0)
    },
    "symbol_Cherry": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,32), 0)
    },
    "symbol_Joker": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,79), 0)
    },
    "symbol_Joker_short": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,32), 0)
    },
    "symbol_Joker_long": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,48), 0)
    },
    "symbol_Melon": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,48), 0)
    },
    "symbol_Orange": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,32), 0)
    },
    "symbol_Plum": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,32), 0)
    },
    "symbol_Star": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,48), 0)
    }
}
*/

export var icons = {
    "symbol_Bar": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,98), 0)
    },
    "symbol_Joker_long": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,98), 0)
    },
    "symbol_Melon": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,98), 0)
    },
    "symbol_Star": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,98), 0)
    },

    "symbol_Bell": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,64), 0)
    },
    "symbol_Dollar": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,64), 0)
    },
    "symbol_Cherry": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,64), 0)
    },
    "symbol_Joker_short": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,64), 0)
    },
    "symbol_Orange": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,64), 0)
    },
    "symbol_Plum": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,64), 0)
    },

    "symbol_Joker": {
        stop: [0],
        blur: [0],
        anim: madnes_join(madnes_fill_range(0,155), 0)
    }

};

export var icons_tmp = new Array();

export var symbols = new Array();
symbols[0] = -1;
symbols[1] = -1;
symbols[2] = -1;
symbols[3] = -1;

export var last_symbol = new Array();
last_symbol[0] = -1;
last_symbol[1] = -1;
last_symbol[2] = -1;
last_symbol[3] = -1;

export var symbols_before_stop = 3;

export var render_move_per_sec = 23; // Symbolu za sekundu
export var render_move_per_sec_free = 27; // Symbolu za sekundu ve free spinu

var assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
var audioPath = assetsPath + "audio/";

function init_game(dname, cfg)
{
    // madnes_game_title = "Joker 27 Plus";
    //
    // madnes_load_init("joker_27_plus", init_game);
    //
    // madnes_set_page_bg(dname, imgsPath + "web/background.png");
    //
    // madnes_set_texture_version(17);

    // madnes_set_ico_size(380, 194);
    // madnes_set_win_factors(25, 50, 125);
    // madnes_set_native_sceen_size(1280, 720);

    // for(var i in to_load_audio)
    // {
    // 	madnes_add_audio(i, to_load_audio[i]);
    // }
    //
    // for(var i in to_load_json)
    // {
    // 	if(infotexts_languages.indexOf(lang) === -1)
    // 	{
    // 		to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
    // 	}
    //
    // 	madnes_add_json(i, to_load_json[i]);
    // }
    //
    // for(var i in to_load)
    // {
    // 	madnes_add_to_load(i, to_load[i]);
    // }
    //
    // for(var i in to_load_fonts)
    // {
    // 	madnes_add_font_to_load(i, to_load_fonts[i]);
    // }

    // madnes_set_default_volume(0.8);
    //
    // madnes_set_sprite('blur', 330, 300);
    // madnes_set_sprite('_sprite', 330, 300);
    // //madnes_set_sprite('font_menu_Big', 40, 40);
    // madnes_set_sprite('font_big-win', 134, 159);
    //
    // madnes_set_sprite('flares_sprite', 1280 / 4, 920 / 4);

    // madnes_set_printdesk_function(joker27plus_print_desk);
    // madnes_set_updatedesk_function(joker27plus_print_reels);
    //
    // madnes_set_rotate_function(joker27plus_rotate_run);
    //
    // madnes_set_infomenu_init_function(joker27plus_infomenu_init);
    // madnes_set_infomenu_open_function(joker27plus_infomenu_open);
    // madnes_set_infomenu_close_function(joker27plus_infomenu_close);
    // madnes_set_infomenu_update_function(joker27plus_infomenu_update);
    // madnes_set_infomenu_left_function(joker27plus_infomenu_left);
    // madnes_set_infomenu_right_function(joker27plus_infomenu_right);
    //
    // madnes_init(dname);
}


// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! Pouze pro dev ucely. Na produkci se muze odebrat.
// !! Prod mat server by nemel podporovat vynuceni vysledku ani v pripade ponechani.
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var force_res = "";
function joker27plus_freespins_force_start(el)
{
    force_res = "spins";
}
function joker27plus_multiwin_force_start(el)
{
    force_res = "multiwin";
}
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

